import type { AxiosInstance } from 'axios';
import { API_PATH_PREFIX } from '@dentexe/types';
import { createApiClient } from './createApiClient';
import type { ApiClientConfig } from './types';

let instance: AxiosInstance | null = null;

export function getApiClient(config?: Partial<ApiClientConfig>): AxiosInstance {
  if (!instance) {
    instance = createApiClient({
      baseURL: `/${API_PATH_PREFIX}`,
      ...config,
    });
  }
  return instance;
}

export function resetApiClient(): void {
  instance = null;
}
